import { v4 } from 'uuid'

import { ReadMappingColumn,ReadMappingData } from '@/endpoints/schemas'

import { ensureValidData } from '../helpers'

export const defaultReadMappingData: Readonly<ReadMappingData> = {
	sourceItems: [],
	sourceItemsLastId: 0,
}

export const getInitialReadMappingData = (name: string, code = '') =>
	ensureValidData(
		{
			name,
			code,
			description: '',
			columns: [],
			columnsLastId: 0,
		},
		defaultReadMappingData,
	)

export const createEmptyReadMappingColumn = (
	columns: ReadMappingColumn[],
): ReadMappingColumn => ({
	id: -1,
	uuid: v4(),
	order: columns.length,
	columnCode: '',
	keyFlag: false,
	mapping: '',
	mappingDescription: '',
	mappingComment: '',
	updateFlag: false,
})
